<script>
import { defineComponent } from 'vue'
import { mapActions, mapGetters, mapState } from 'vuex'

export default defineComponent({
  name: 'BuscaProfissionais',
  computed: {
    ...mapGetters('SetupApp', ['estilo']),
    ...mapState('SetupApp', ['apiFuncionalidade']),
    ...mapState('Func53', ['paciente', 'idLocal', 'idAgenda', 'idServico', 'listaLocal']),
    corPrimaria () {
      return this.estilo.aplicacao.corPrimariaAplicacao
    }
  },
  data () {
    return {
      search: null
    }
  },
  methods: {
    ...mapActions('Func53', ['setNomePrestador']),
    async submit () {
      if (!this.search) {
        this.$message.error('Digite o nome que deseja encontrar.')
        return
      }

      const payload = {
        paciente: this.paciente,
        tipoAgenda: this.idAgenda,
        data: this.dataSelecionada,
        nomeProfissional: this.search
      }

      const res = await this.apiFuncionalidade.listaAgendasProfissionais({
        payload,
        loading: true,
        handlerErrorIgnore: true
      })
      if (!res || !res.data || !res.data.profissionaisAgendas || res.data.profissionaisAgendas.length === 0) {
        this.$message.error('Nenhum profissional encontrado.')

        return
      }

      await this.setNomePrestador(this.search)
      return this.$router.replace({ query: { step: 5 } })
    }
  }
})
</script>

<template>
  <div class="busca-profissionais">
    <el-input v-model="search" type="text" prefix-icon="el-icon-search" placeholder="Pesquisar nome..." clearable></el-input>
    <el-button type="primary" class="custom-btn" :style="{backgroundColor: corPrimaria}" @click="submit">Buscar</el-button>
  </div>
</template>
<style>
.custom-btn {
  padding: 10px 0;
}
</style>
<style scoped>
.busca-profissionais {
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
</style>
